var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"fullscreen",staticClass:"fullscreen"},[_c('div',{staticClass:"world-wrapper"},[_c('canvas',{ref:"world",attrs:{"id":"world"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }